// extracted by mini-css-extract-plugin
export var drawerPaper = "_1x-0";
export var itemCard = "_1x-1";
export var itemImage = "_1x-2";